// extracted by mini-css-extract-plugin
module.exports = {"actionButtonsContainer":"ReferralSources_actionButtonsContainer__2QAc9","actionColumn":"ReferralSources_actionColumn__2Yxjw","textButton":"ReferralSources_textButton__E3O-W"};